import { render, staticRenderFns } from "./VerificationBanner.vue?vue&type=template&id=43221e0a&scoped=true&"
import script from "./VerificationBanner.vue?vue&type=script&lang=js&"
export * from "./VerificationBanner.vue?vue&type=script&lang=js&"
import style0 from "./VerificationBanner.vue?vue&type=style&index=0&id=43221e0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43221e0a",
  null
  
)

export default component.exports